

import Vue from "vue";
import { SaleService } from "@/services/sale-service";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import { PdfViewer } from "@/utils/pdf-viewer";

export default Vue.extend({
	data(){
		return {
			pdfViewer: new PdfViewer(),
			url: ""
		};
	},
	props: {
		layout: Object as () => SaleLayout
	},
	watch: {
		layout: {
			deep: true,
			immediate: true,
			handler() {
				this.preview();
			}
		}
	},
	methods: {
		async preview() {
			let blob = await SaleService.getSaleLayoutPreview(this.layout, "nl-be");
			this.pdfViewer.setPdfBlob(blob);
			await this.pdfViewer.open();
			this.url = this.pdfViewer.getURL();
		}
	},
	destroyed(){
		this.pdfViewer.close();
	},
	components: {},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
